import { InputLabel } from '../../../../../components/InputGroup/styles/InputGroupLabel.style';
import styled from 'styled-components';

const ChooseLocationLabel = styled(InputLabel)`
  margin: 10px 0 0 0;
  color: white;
`;

export default ChooseLocationLabel;
